var ProjectModal = function () {

	this.init = function () {
		$('[data-component="project-modal"]').on('shown.bs.modal', function () {
			$('.image-slider').slick({
				dots: true,
				infinite: false,
				arrows: false,
				adaptiveHeight: true,
			});
		})

	}

	return this.init();
}
